<template>
  <div class="checkout checkoutIsActive">
    <div class="checkout__order" style="width:100%">
      <div class="checkout__order-inner" style="padding: 0">
        <table class="checkout__summary" style="margin: 0">
          <thead>
            <tr>
              <th></th>
              <th>Price</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th colspan="2" style="padding-top: 10px; font-size: 1em">
                Total
                <span class="checkout__total" style="font-size: 1em">{{
                  order.display_total
                }}</span>
              </th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="item in productOrderItem" :key="item.name">
              <td style="font-size: 1em">
                {{ item.name }}
                <span style="font-size: 1em">X {{ item.quantity }}</span>
              </td>
              <td style="font-size: 1em">{{ item.display_total }}</td>
            </tr>
            <tr v-if="couponOrderItem">
              <td style="font-size: 1em">
                {{ couponOrderItem.name }}
              </td>
              <td style="font-size: 1em">
                {{ couponOrderItem.display_total }}
              </td>
            </tr>
            <tr
              v-for="shipping in shippingOrderItems"
              :key="shipping.name + '_shipping'"
            >
              <td style="font-size: 1em; color:grey">
                Shipping - {{ shipping.name }}
              </td>
              <td style="font-size: 1em; color:grey">
                {{ shipping.display_total }}
              </td>
            </tr>
            <tr v-for="tax in taxOrderItems" :key="tax.name">
              <td style="font-size: 1em; color:grey">
                {{ tax.name }}
              </td>
              <td style="font-size: 1em; color:grey">
                {{ tax.display_total }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="showServiceFees" style="text-align: left; margin-top: 1em">
      <p>{{ strServiceFeeDescription }}</p>
    </div>
    <template
      v-if="hasProductsWithShippingLimitsMet && showShippingLimitWarnings"
    >
      <div class="ui yellow message">
        <el-icon name="truck"></el-icon> You have reached the shipping limit for
        the following books:
        <div style="text-align: start" class="ml-3 mt-2">
          <ul
            v-for="product in getProductsWithShippingLimitsMet"
            :key="product.id"
          >
            <li>
              {{ product.name }} - max per order: {{ product.shipping_limit }}
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-if="isForSchoolPickup">
      <div class="ui blue message">
        <i class="fas fa-store mr-2"></i>This order is for
        <strong>pick up</strong> at the school (when it is ready).
      </div>
    </template>
    <template v-else-if="isShipped">
      <div class="ui blue message">
        <i class="fas fa-store mr-2"></i>This order will be shipped to you (when
        it is ready).
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "OrderSummary",
  data() {
    return {
      deliveryMethod: ""
    };
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    showShippingLimitWarnings: {
      type: Boolean,
      default: false
    },
    showServiceFees: {
      type: Boolean,
      default: false
    },
    serviceFeeLabel: {
      type: String,
      default: 'fulfilment fee'
    }
  },
  computed: {
    couponOrderItem() {
      return this.order.items["coupon"];
    },
    productOrderItem() {
      return this.order.items["product"];
    },
    taxOrderItems() {
      return this.order.items["tax"];
    },
    shippingOrderItems() {
      return this.order.items["shipping"];
    },
    serviceFeeDisplayTotal () {
      return this.order.application_fee_display_total;
    },
    strServiceFeeDescription () {
      return this.order.application_fee_customer_description;
    },
    getProductsWithShippingLimitsMet() {
      if (!this.isShipped) return [];
      return this.productOrderItem.filter(product => {
        return (
          product.quantity === product.shipping_limit &&
          product.is_shipping_limit_enabled
        );
      });
    },
    hasProductsWithShippingLimitsMet() {
      return this.getProductsWithShippingLimitsMet.length > 0;
    },
    // Right now, pickup from the school is the only delivery option for physical products.
    // It is set by the server automatically if the order contains items
    // which are eligible for pickup.
    // Here, we'll show the customer a message so this is clear.
    isForSchoolPickup() {
      return this.order.is_for_school_pickup;
    },
    isShipped() {
      return this.order.is_shipped;
    },
    canChangeDeliveryMethod() {
      return this.order.can_delivery_method_be_changed;
    }
  },
  mounted() {
    if (this.isForSchoolPickup) {
      this.deliveryMethod = "pickup";
    } else if (this.isShipped) {
      this.deliveryMethod = "shipped";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/sass/cart.scss";
</style>
